/**
 * component to render in nominations tab at How to Nominate page
 */
const NominationsSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-50 px-5 py-4 font-public-sans">
      <p>Nominations for SI Awards 2025 are closed.</p>
    </div>
  );
};

export default NominationsSection;
